module.exports = __webpack_public_path__ + "media/rosette-surprise-crate.65344ac4.mp4";